import {
  ApplyFacilitiesFormSchema,
  CustomFieldInfoFormSchema,
} from 'modals/CustomFieldModal/CustomFieldModal.types';
import { B2B_EDIT_CUSTOM_FIELDS } from 'constants/endpoints';
import { METHOD_PUT } from 'requests';
import { ApiRequestConfigType } from 'requests/index.types';

export const API_PUT_customField = (
  createCustomFieldFormPayload: CustomFieldInfoFormSchema,
  applyFacilitiesFormPayload: ApplyFacilitiesFormSchema,
): ApiRequestConfigType => {
  return {
    __typename: 'LegacyAPI',
    url: B2B_EDIT_CUSTOM_FIELDS(createCustomFieldFormPayload.id),
    method: METHOD_PUT,
    body: {
      community_ids: applyFacilitiesFormPayload.communityIds.map((communityId) =>
        Number.parseInt(communityId),
      ),
      custom_field: {
        placeholder: createCustomFieldFormPayload.placeholder,
        prefill_default: createCustomFieldFormPayload.preFillDefault,
        mobile: createCustomFieldFormPayload.mobile,
        all_communities: applyFacilitiesFormPayload.allFacilities,
        custom_field_options_attributes: createCustomFieldFormPayload.dropdownOptions.map(
          (dropdownOption) => ({
            value: dropdownOption,
          }),
        ),
      },
    },
  };
};
